import { UntilDestroy } from '@ngneat/until-destroy';
import { Directive, Input } from '@angular/core';
import { ICooperativeData } from '../../models';

@UntilDestroy()
@Directive()
export class CooperativeInformationCardBaseComponent {
  @Input() cooperativeData: ICooperativeData;
  @Input() className = '';
}
